/**
 * Global state that keeps track of whether the scroll should be locked.
 * Uses a counter so multiple consumers (Modal, Menu, etc.) can lock/unlock independently
 * without interfering with each other.
 */
const scrollLockState = $state({ count: 0 });

export const lockScroll = {
	get lock(): boolean {
		return scrollLockState.count > 0;
	},
	set lock(value: boolean) {
		if (value) {
			scrollLockState.count++;
		} else {
			scrollLockState.count = Math.max(0, scrollLockState.count - 1);
		}
	},
};
